import { render } from "./TurboTatu.vue?vue&type=template&id=100495d0&scoped=true"
import script from "./TurboTatu.vue?vue&type=script&lang=js"
export * from "./TurboTatu.vue?vue&type=script&lang=js"

import "./TurboTatu.vue?vue&type=style&index=0&id=100495d0&scoped=true&lang=css"

import exportComponent from "/home/frog/Documents/vue/AeAAppDev/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-100495d0"]])

export default __exports__